import { CONST } from './app.constant';
export default function getEnv() {
  let urlVal = CONST.ENV_URL_DEV;
  if (window.location.hostname.includes('p131558-e1281250')) {
    urlVal = CONST.ENV_URL_DEV;
  } else if (window.location.hostname.includes('p131558-e1281330')) {
    urlVal = CONST.ENV_URL_UAT;
  } else if (
    window.location.hostname.includes('p131558-e1281329') ||
    window.location.hostname.includes('www.ibm.com')
  ) {
    urlVal = CONST.ENV_URL_PROD;
  }
  return urlVal;
}

export const environment = {
  restUrlDev:
    'https://ibm-pes-privacyportal-backend-test-cicd-backend.2c666006.public.multi-containers.ibm.com/api/v1',
  restUrlUat:
    'https://privacy-backend-uat-uat-cicd-backend.2c666006.public.multi-containers.ibm.com/api/v1',
  restUrlProd:
    'https://ibm-pes-privacyportal-backend-test-bkpreprod-oprt.53061809.public.multi-containers.ibm.com/api/v1',
  localHostUrl: 'http://localhost:9900/api/v1',
  idaasUserStatus: 'https://login.ibm.com/v1/mgmt/idaas/user/status',
  chatbotIframeUrl:
    'https://trustbot-token.968d96a4.public.multi-containers.ibm.com/auth/token/',
  loginUrlDsrFrom:
    'https://login.ibm.com/oidc/endpoint/default/authorize?redirect_uri=https%3A%2F%2Fmyibm.ibm.com%2FOIDCHandler.html&response_type=token&client_id=v18LoginProdCI&scope=openid&state=https%3A%2F%2Fwww.ibm.com%2Ftrust%2Fprivacy%2Fdsr-submission&nonce=8675309',
  loginUrlDsrStatus:
    'https://login.ibm.com/oidc/endpoint/default/authorize?redirect_uri=https%3A%2F%2Fmyibm.ibm.com%2FOIDCHandler.html&response_type=token&client_id=v18LoginProdCI&scope=openid&state=https%3A%2F%2Fpublish-p131558-e1281250.adobeaemcloud.com%2Fcontent%2Fadobe-cms%2Flanguage-masters%2Fen%2Ftrust%2Fprivacy%2Fdsr-tracking.html&nonce=8675309',
  profileId: 'https://api.ibm.com/profilemgmt/run/ibmidprofile/v2/users',
};
